import { Component, app } from "modular-openscriptjs";
import { uniqueId, either, closeOffcanvas } from "../../helpers";
import { offcanvasTypes } from "../../fotastart";

const h = app("h");

export default class Offcanvas extends Component {
    render(config, ...args) {
        const id = `offcanvas-${config?.uid ?? uniqueId()}`;
        this.id = id;
        const title = config?.title ?? "";
        const position = offcanvasTypes.includes(config?.position) ? config?.position : offcanvasTypes[0];
        const footer = config?.footer ?? null;
        const closeButton = config?.closeButton ?? true;

        return h.$(
            h.div(
                {
                    id: id,
                    class: [
                        "wab-offcanvas-backdrop",
                        `wab-offcanvas-${position}`,
                    ].join(" ").trim(),
                },
                h.div(
                    { class: "wab-offcanvas" },
                    either(title || closeButton, h.div(
                        { class: "wab-offcanvas-header" },
                        either(title, h.h2({ class: "wab-offcanvas-title" }, title)),
                        either(closeButton, h.button({
                            class: "wab-offcanvas-close",
                            onclick: h.func("closeOffcanvas", id),
                            "aria-label": "Close offcanvas",
                        }))
                    )),
                    h.div({ class: "wab-offcanvas-body" }, ...args),
                    either(footer, h.div({ class: "wab-offcanvas-footer" }, footer))
                )
            )
        );
    }

    cleanUp() {
        super.cleanUp();
        if (this.id) {
            closeOffcanvas(this.id);
        }
    }
}
